import styles from './ring-number-cell.module.scss';

type Props = {
  ringNumber: number | null | undefined;
  currentRingNumber: number | null;
};

const getClassName = (
  ringNumber: number | null | undefined,
  currentRingNumber: number | null,
): string => {
  if (ringNumber == null || currentRingNumber == null) {
    return '';
  }
  if (ringNumber === currentRingNumber) {
    return styles.current;
  }
  if (ringNumber > currentRingNumber) {
    return styles.future;
  }
  return '';
};

export const RingNumberCell = ({ ringNumber, currentRingNumber }: Props) => {
  return (
    <span className={getClassName(ringNumber, currentRingNumber)}>
      {ringNumber ?? '-'}
    </span>
  );
};
